import {
  type BehaviorMapEventHandler,
  type LngLat,
  type MapLocationRequest,
  Image,
  Map as BaseMap,
  MapListener,
} from '@yandex-delivery/blocks'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import {useI18n} from '@yandex-delivery/core/i18n'
import React, {memo, useCallback} from 'react'

import {useConfigContext} from '../../../../../../contexts/ConfigContext'
import {getMapLocale} from '../../../../../../lib/getMapLocale'
import {tagToUrl} from '../../../../../../lib/tagToUrl'
import * as styles from './Map.classes'

/** Пропсы компонента Map */
type MapProps = {
  /** Коллбэк на изменение локации */
  onLocationChange: (coordinates: LngLat) => void
  location: MapLocationRequest
  addressInfoHeight?: number
  children?: React.ReactNode
}

/** Тег иконки пина */
const ADDRESS_PIN_ICON = 'delivery_address_pin'

/**
 * Компонент с картой и пином посередине,
 * который отслеживает координаты текущего центра карты при смене позиции пользователем.
 */
export const Map = memo<MapProps>(function Map({location, onLocationChange, addressInfoHeight, children}) {
  const i18n = useI18n()

  const {lang} = useConfigContext()

  const handleActionEnd = useCallback<BehaviorMapEventHandler>(
    ({location: newLocation}) => {
      onLocationChange(newLocation.center)
    },
    [onLocationChange],
  )

  const mapLocale = getMapLocale(lang)

  return (
    <div className={styles.map} style={{blockSize: `calc(100% - ${addressInfoHeight ?? 0}px + ${spacing(2)})`}}>
      <BaseMap errorMessage={i18n('map_load_error', 'Не удалось загрузить карту')} lang={mapLocale} location={location}>
        <Image className={styles.pinIcon} height={72} src={tagToUrl(ADDRESS_PIN_ICON)} />
        <MapListener onActionEnd={handleActionEnd} />
        {children}
      </BaseMap>
    </div>
  )
})
